import { useNavigate } from 'react-router-dom'

import type { ReactElement } from 'react'
import type { IAppSummary } from '~/types/application'
import type { IPageContainerCreateUpdate } from '~/types/page-container'
import type { ITemplate } from '~/types/template'

import PageContainerForm from '../Form'

import MwMLoader from '~/components/MwMLoader'
import { useTemplateConfigWithTranslationValues } from '~/hooks/useTemplateConfig'
import { useCreatePageContainerFromTemplateMutation } from '~/queries/page-containers'
import { displayToast } from '~/utils/toast'

const PageContainerCreation = ({
  selectedApp,
  selectedTemplateKey,
  template,
  templateVersion,
}: {
  selectedApp: IAppSummary
  selectedTemplateKey: string
  template: ITemplate
  templateVersion: string
}): ReactElement | null => {
  const navigate = useNavigate()

  const { isLoading, templateConfig } = useTemplateConfigWithTranslationValues({
    applicationSummary: selectedApp,
    templateKey: selectedTemplateKey,
  })

  const { mutateAsync: createPageContainerMutation } = useCreatePageContainerFromTemplateMutation()

  const handleSubmit = async (data: IPageContainerCreateUpdate) => {
    try {
      const pageContainer = await createPageContainerMutation(data)
      displayToast('Page container successfully saved', 'success')
      navigate(`/dynamic-screens/page-containers/${pageContainer.uuid}`)
    } catch {
      displayToast('Page container could not be created', 'error')
    }
  }

  if (isLoading) {
    return (
      <div className="no-template-container">
        <MwMLoader category="item" />
      </div>
    )
  }

  return templateConfig ? (
    <PageContainerForm
      appSummary={selectedApp}
      isUnity={template.is_unity}
      onSubmit={handleSubmit}
      template={template}
      templateConfig={templateConfig}
      templateVersion={templateVersion}
    />
  ) : null
}

export default PageContainerCreation
